module.exports = __webpack_public_path__ + "static/02-94a330c7a2216b4f91cbd5684e3795a2.jpg";